@if (loaded()) {
  @if (
    (testData() || displayRaffleDraws() || previewMode()) && (raffleWinnersWidget().raffle_item || isTemplateMode())
  ) {
    <div
      class="raffle-winners-widget"
      [style.background-color]="backgroundColor()"
      [style.color]="textColor()"
      [style.font-size.cqw]="fontSizeCqw()"
      [style.font-family]="fontFamily()"
      [style.font-weight]="fontWeight()"
      [style.text-align]="textAlign()"
    >
      @let pageIndexValue = pageIndex();
      @for (page of [pageIndexValue]; track page) {
        <div
          class="raffle-winners-list fade-in"
          [style.grid-template-columns]="gridTemplateColumns()"
          [style.grid-template-rows]="gridTemplateRows()"
        >
          @for (winner of displayWinners(); track winner.uuid) {
            <div class="raffle-winners-row">
              <div
                class="raffle-winners-left"
                [style.background-color]="leftBackgroundColor()"
                [style.color]="leftTextColor()"
                [style.justify-content]="justifyContent()"
              >
                <gb-icon height="2cqw" icon="ticket"></gb-icon>
                {{ getLeftLabel(winner) }}
              </div>
              <div
                class="raffle-winners-right"
                [style.background-color]="rightBackgroundColor()"
                [style.color]="rightTextColor()"
                [style.justify-content]="justifyContent()"
              >
                {{ getRightLabel(winner) }}
              </div>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <gb-presenter-widget-placeholder>
      <h1>{{ 'PRESENTER.RAFFLE_WINNERS_WIDGET.PLACEHOLDER_TITLE' | translate }}</h1>
      <span>{{ 'PRESENTER.RAFFLE_WINNERS_WIDGET.PLACEHOLDER_SUBTITLE' | translate }}</span>
    </gb-presenter-widget-placeholder>
  }
  @if (isLaunchMode() || (!inPreviewMode() && !isTemplateMode())) {
    <gb-presenter-widget-raffle-item-label
      (click)="raffleWinnersWidget().raffle_item ?? openRaffleItemWarning.emit()"
      [raffleItemName]="raffleItemName()"
      [isLaunchMode]="isLaunchMode()"
    ></gb-presenter-widget-raffle-item-label>
  }
} @else {
  <gb-skeleton-loader
    [rows]="raffleWinnersWidget().rows || 5"
    [columns]="raffleWinnersWidget().columns || 1"
    direction="grid"
    borderRadius="0.9cqw"
    [gap]="0.7"
    gapUnit="cqw"
  ></gb-skeleton-loader>
}
